import AbstractSettingsTool from "../AbstractSettingsTool";

export default class SettingsTool extends AbstractSettingsTool { }
